import React from 'react';

const RzpCallbackHandler = () => {
  const queryParams = new URLSearchParams(window.location.search);
  console.log(queryParams);
  return <div>RzpCallbackHandler</div>;
};

export default RzpCallbackHandler;
